import { RouteLocationNormalized } from 'vue-router'

import { useEquipmentStore, Equipment } from '@/entities/equipment'

export const functionalKeysPropsFn = (to: RouteLocationNormalized): unknown => {
  const { getEquipmentByMac } = useEquipmentStore()

  const { mac } = to.params
  const equipment = getEquipmentByMac(mac as Equipment['mac'])
  return {
    mac,
    equipment,
  }
}
